module.exports = __webpack_public_path__ + "img/bg-8.97080a7b.webp";